

export const frontMatter = {
	title: 'Saving State'
};
export const contentTitle = 'Live Example';
export const metadata = {
  "id": "core/state/save",
  "title": "Saving State",
  "description": "This section describes how to serialize a dockview instance.",
  "source": "@site/docs/core/state/save.mdx",
  "sourceDirName": "core/state",
  "slug": "/core/state/save",
  "permalink": "/docs/core/state/save",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "frontMatter": {
    "title": "Saving State"
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Loading State",
    "permalink": "/docs/core/state/load"
  },
  "next": {
    "title": "Locked",
    "permalink": "/docs/core/locked"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {CodeRunner} from '@site/src/components/ui/codeRunner';
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "This section describes how to serialize a dockview instance."
    }), "\n", _jsx(DocRef, {
      declaration: "DockviewApi",
      methods: ['toJSON', 'onDidLayoutChange']
    }), "\n", _jsxs(_components.p, {
      children: ["To retrieve the current state of the dock call ", _jsx(_components.code, {
        children: "toJSON()"
      }), ".\nYou can listen to the event ", _jsx(_components.code, {
        children: "onDidlayoutChange"
      }), " to determine when the layout has changed."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const [api, setApi] = React.useState<DockviewApi>();\n\nReact.useEffect(() => {\n  if(!api) {\n    return;\n  }\n\n  const disposable = api.onDidLayoutChange(() => {\n    const layout: SerializedDockview = api.toJSON();\n    localStorage.setItem('my_layout', JSON.stringify(layout));\n  });\n\n  return () => disposable.dispose();\n}, [api]);\n\nconst onReady = (event: DockviewReadyEvent) => {\n  setApi(event.api);\n}\n\nreturn <DockviewComponent onReady={onReady}/>\n"
      })
    }), "\n", _jsx(_components.h1, {
      id: "live-example",
      children: "Live Example"
    }), "\n", _jsx(CodeRunner, {
      id: "dockview/layout"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

